var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AssetModel_company_id, _AssetModel_name, _AssetModel_parent_id, _AssetModel_status, _AssetModel_photo_url, _AssetModel_qr_code_url, _AssetModel_created_at, _AssetModel_updated_at, _AssetModel_location_id, _AssetModel_cost, _AssetModel_purchase_date, _AssetModel_warranty_date, _AssetModel_fields;
export var AssetStatus;
(function (AssetStatus) {
    AssetStatus["ACTIVE"] = "Active";
    AssetStatus["INACTIVE"] = "Inactive";
})(AssetStatus || (AssetStatus = {}));
export class AssetModel {
    constructor(data = {}) {
        _AssetModel_company_id.set(this, void 0);
        _AssetModel_name.set(this, void 0);
        _AssetModel_parent_id.set(this, void 0);
        _AssetModel_status.set(this, void 0);
        _AssetModel_photo_url.set(this, void 0);
        _AssetModel_qr_code_url.set(this, void 0);
        _AssetModel_created_at.set(this, void 0);
        _AssetModel_updated_at.set(this, void 0);
        _AssetModel_location_id.set(this, void 0);
        _AssetModel_cost.set(this, void 0);
        _AssetModel_purchase_date.set(this, void 0);
        _AssetModel_warranty_date.set(this, void 0);
        _AssetModel_fields.set(this, void 0);
        // Ensure data is an object
        const safeData = data || {};
        __classPrivateFieldSet(this, _AssetModel_company_id, safeData.company_id || '', "f");
        __classPrivateFieldSet(this, _AssetModel_name, safeData.name || '', "f");
        __classPrivateFieldSet(this, _AssetModel_parent_id, safeData.parent_id || null, "f");
        __classPrivateFieldSet(this, _AssetModel_status, safeData.status || AssetStatus.ACTIVE, "f");
        __classPrivateFieldSet(this, _AssetModel_photo_url, safeData.photo_url || null, "f");
        __classPrivateFieldSet(this, _AssetModel_qr_code_url, safeData.qr_code_url || null, "f");
        // Handle date fields - store as Unix timestamps in milliseconds
        __classPrivateFieldSet(this, _AssetModel_created_at, safeData.created_at ?
            (typeof safeData.created_at === 'number' ? safeData.created_at : Date.now()) :
            Date.now(), "f");
        __classPrivateFieldSet(this, _AssetModel_updated_at, safeData.updated_at ?
            (typeof safeData.updated_at === 'number' ? safeData.updated_at : Date.now()) :
            Date.now(), "f");
        // Handle new required and optional fields
        __classPrivateFieldSet(this, _AssetModel_location_id, safeData.location_id || '', "f");
        __classPrivateFieldSet(this, _AssetModel_cost, safeData.cost !== undefined ? safeData.cost : null, "f");
        __classPrivateFieldSet(this, _AssetModel_purchase_date, safeData.purchase_date !== undefined ?
            (typeof safeData.purchase_date === 'number' ? safeData.purchase_date : null) :
            null, "f");
        __classPrivateFieldSet(this, _AssetModel_warranty_date, safeData.warranty_date !== undefined ?
            (typeof safeData.warranty_date === 'number' ? safeData.warranty_date : null) :
            null, "f");
        // Handle custom fields - simple structure
        __classPrivateFieldSet(this, _AssetModel_fields, Array.isArray(safeData.fields) ? safeData.fields : [], "f");
    }
    // Getters
    get company_id() {
        return __classPrivateFieldGet(this, _AssetModel_company_id, "f");
    }
    set company_id(company_id) {
        __classPrivateFieldSet(this, _AssetModel_company_id, company_id, "f");
    }
    get name() {
        return __classPrivateFieldGet(this, _AssetModel_name, "f");
    }
    set name(name) {
        __classPrivateFieldSet(this, _AssetModel_name, name, "f");
    }
    get parent_id() {
        return __classPrivateFieldGet(this, _AssetModel_parent_id, "f");
    }
    set parent_id(parent_id) {
        __classPrivateFieldSet(this, _AssetModel_parent_id, parent_id, "f");
    }
    get photo_url() {
        return __classPrivateFieldGet(this, _AssetModel_photo_url, "f");
    }
    set photo_url(photo_url) {
        __classPrivateFieldSet(this, _AssetModel_photo_url, photo_url, "f");
    }
    get qr_code_url() {
        return __classPrivateFieldGet(this, _AssetModel_qr_code_url, "f");
    }
    set qr_code_url(qr_code_url) {
        __classPrivateFieldSet(this, _AssetModel_qr_code_url, qr_code_url, "f");
    }
    get status() {
        return __classPrivateFieldGet(this, _AssetModel_status, "f");
    }
    set status(status) {
        __classPrivateFieldSet(this, _AssetModel_status, status, "f");
    }
    get created_at() {
        return __classPrivateFieldGet(this, _AssetModel_created_at, "f");
    }
    set created_at(created_at) {
        __classPrivateFieldSet(this, _AssetModel_created_at, created_at, "f");
    }
    get updated_at() {
        return __classPrivateFieldGet(this, _AssetModel_updated_at, "f");
    }
    set updated_at(updated_at) {
        __classPrivateFieldSet(this, _AssetModel_updated_at, updated_at, "f");
    }
    // New field getters and setters
    get location_id() {
        return __classPrivateFieldGet(this, _AssetModel_location_id, "f");
    }
    set location_id(location_id) {
        __classPrivateFieldSet(this, _AssetModel_location_id, location_id, "f");
    }
    get cost() {
        return __classPrivateFieldGet(this, _AssetModel_cost, "f");
    }
    set cost(cost) {
        __classPrivateFieldSet(this, _AssetModel_cost, cost, "f");
    }
    get purchase_date() {
        return __classPrivateFieldGet(this, _AssetModel_purchase_date, "f");
    }
    set purchase_date(purchase_date) {
        __classPrivateFieldSet(this, _AssetModel_purchase_date, purchase_date, "f");
    }
    get warranty_date() {
        return __classPrivateFieldGet(this, _AssetModel_warranty_date, "f");
    }
    set warranty_date(warranty_date) {
        __classPrivateFieldSet(this, _AssetModel_warranty_date, warranty_date, "f");
    }
    // Custom fields methods
    get fields() {
        return [...__classPrivateFieldGet(this, _AssetModel_fields, "f")];
    }
    set fields(fields) {
        __classPrivateFieldSet(this, _AssetModel_fields, [...fields], "f");
    }
    addField(field) {
        const existingIndex = __classPrivateFieldGet(this, _AssetModel_fields, "f").findIndex(f => f.name === field.name);
        if (existingIndex >= 0) {
            __classPrivateFieldGet(this, _AssetModel_fields, "f")[existingIndex] = field;
        }
        else {
            __classPrivateFieldGet(this, _AssetModel_fields, "f").push(field);
        }
        __classPrivateFieldSet(this, _AssetModel_updated_at, Date.now(), "f");
    }
    removeField(fieldName) {
        const index = __classPrivateFieldGet(this, _AssetModel_fields, "f").findIndex(f => f.name === fieldName);
        if (index >= 0) {
            __classPrivateFieldGet(this, _AssetModel_fields, "f").splice(index, 1);
            __classPrivateFieldSet(this, _AssetModel_updated_at, Date.now(), "f");
            return true;
        }
        return false;
    }
    getField(fieldName) {
        return __classPrivateFieldGet(this, _AssetModel_fields, "f").find(f => f.name === fieldName) || null;
    }
    updateFieldValue(fieldName, value) {
        const field = this.getField(fieldName);
        if (field) {
            field.value = value;
            __classPrivateFieldSet(this, _AssetModel_updated_at, Date.now(), "f");
            return true;
        }
        return false;
    }
    hasFields() {
        return __classPrivateFieldGet(this, _AssetModel_fields, "f").length > 0;
    }
    getFieldCount() {
        return __classPrivateFieldGet(this, _AssetModel_fields, "f").length;
    }
    getFieldsByType(type) {
        return __classPrivateFieldGet(this, _AssetModel_fields, "f").filter(field => field.type === type);
    }
    // Static methods
    static get statuses() {
        return Object.values(AssetStatus);
    }
    // Business logic methods
    isActive() {
        return __classPrivateFieldGet(this, _AssetModel_status, "f") === AssetStatus.ACTIVE;
    }
    isInactive() {
        return __classPrivateFieldGet(this, _AssetModel_status, "f") === AssetStatus.INACTIVE;
    }
    hasPhoto() {
        return __classPrivateFieldGet(this, _AssetModel_photo_url, "f") !== null && __classPrivateFieldGet(this, _AssetModel_photo_url, "f").trim() !== '';
    }
    hasQRCode() {
        return __classPrivateFieldGet(this, _AssetModel_qr_code_url, "f") !== null && __classPrivateFieldGet(this, _AssetModel_qr_code_url, "f").trim() !== '';
    }
    hasParent() {
        return __classPrivateFieldGet(this, _AssetModel_parent_id, "f") !== null && __classPrivateFieldGet(this, _AssetModel_parent_id, "f").trim() !== '';
    }
    isRootAsset() {
        return __classPrivateFieldGet(this, _AssetModel_parent_id, "f") === null || __classPrivateFieldGet(this, _AssetModel_parent_id, "f").trim() === '';
    }
    // Serialization methods
    toJSON() {
        const json = {
            company_id: __classPrivateFieldGet(this, _AssetModel_company_id, "f"),
            name: __classPrivateFieldGet(this, _AssetModel_name, "f"),
            parent_id: __classPrivateFieldGet(this, _AssetModel_parent_id, "f"),
            status: __classPrivateFieldGet(this, _AssetModel_status, "f"),
            photo_url: __classPrivateFieldGet(this, _AssetModel_photo_url, "f"),
            qr_code_url: __classPrivateFieldGet(this, _AssetModel_qr_code_url, "f"),
            created_at: __classPrivateFieldGet(this, _AssetModel_created_at, "f"),
            updated_at: __classPrivateFieldGet(this, _AssetModel_updated_at, "f"),
            location_id: __classPrivateFieldGet(this, _AssetModel_location_id, "f"),
            cost: __classPrivateFieldGet(this, _AssetModel_cost, "f"),
            purchase_date: __classPrivateFieldGet(this, _AssetModel_purchase_date, "f"),
            warranty_date: __classPrivateFieldGet(this, _AssetModel_warranty_date, "f"),
            fields: __classPrivateFieldGet(this, _AssetModel_fields, "f"),
        };
        return json;
    }
    toFirestore() {
        return {
            company_id: __classPrivateFieldGet(this, _AssetModel_company_id, "f"),
            name: __classPrivateFieldGet(this, _AssetModel_name, "f"),
            parent_id: __classPrivateFieldGet(this, _AssetModel_parent_id, "f"),
            status: __classPrivateFieldGet(this, _AssetModel_status, "f"),
            photo_url: __classPrivateFieldGet(this, _AssetModel_photo_url, "f"),
            qr_code_url: __classPrivateFieldGet(this, _AssetModel_qr_code_url, "f"),
            created_at: __classPrivateFieldGet(this, _AssetModel_created_at, "f"),
            updated_at: __classPrivateFieldGet(this, _AssetModel_updated_at, "f"),
            location_id: __classPrivateFieldGet(this, _AssetModel_location_id, "f"),
            cost: __classPrivateFieldGet(this, _AssetModel_cost, "f"),
            purchase_date: __classPrivateFieldGet(this, _AssetModel_purchase_date, "f"),
            warranty_date: __classPrivateFieldGet(this, _AssetModel_warranty_date, "f"),
            fields: __classPrivateFieldGet(this, _AssetModel_fields, "f"),
        };
    }
    generateId() {
        return `asset_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
}
_AssetModel_company_id = new WeakMap(), _AssetModel_name = new WeakMap(), _AssetModel_parent_id = new WeakMap(), _AssetModel_status = new WeakMap(), _AssetModel_photo_url = new WeakMap(), _AssetModel_qr_code_url = new WeakMap(), _AssetModel_created_at = new WeakMap(), _AssetModel_updated_at = new WeakMap(), _AssetModel_location_id = new WeakMap(), _AssetModel_cost = new WeakMap(), _AssetModel_purchase_date = new WeakMap(), _AssetModel_warranty_date = new WeakMap(), _AssetModel_fields = new WeakMap();
//# sourceMappingURL=AssetModel.js.map